module.exports = __webpack_public_path__ + "assets/img/busy_3.45a6118a.png";